/* T3028: the gold dot beside a person's name where their latest checks hold an open suggestion,
   in the Medium confidence pill's color. Every value a token. */
.dot {
  display: inline-block;
  flex: none;
  inline-size: var(--suggestion-dot-size);
  block-size: var(--suggestion-dot-size);
  margin-inline-start: var(--space-1);
  border-radius: 50%;
  background: var(--status-warning-text);
  vertical-align: middle;
}
